import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { LocationsListDialogContent } from './components/locationsListDialogContent/LocationsListDialogContent'
import { LocationsListDialogFooter } from './components/locationsListDialogFooter/LocationsListDialogFooter'
import { LocationsListDialogHeader } from './components/locationsListDialogHeader/LocationsListDialogHeader'

interface ILocationsListDialogProps {
  locations: string
  onClose: () => void
}

export const LocationsListDialog: FC<ILocationsListDialogProps> = ({ locations, onClose }) => {
  return (
    <ModalDialog
      show
      onClose={onClose}
      size="sm"
      header={LocationsListDialogHeader}
      content={LocationsListDialogContent}
      footer={() => <LocationsListDialogFooter onClose={onClose} />}
      contentProps={{
        locations,
      }}
    />
  )
}
